import React from 'react';
import { ReactComponent as AdaptIcon } from 'Assets/svg/adapt-logo.svg';
import { ReactComponent as SwapIcon } from 'Assets/svg/swap.svg';
import Button from 'Components/common/Button';
import crmIntegrationState from 'Stores/crmIntegration';
import enrichmentState from 'Stores/enrichment';
import { Utils } from 'Utils/utils';
import { MX_ENRICHMENT_EVENTS } from 'Utils/constants';

const EmptyStateMessage = props => {
  const {
    crmLogoData,
    title,
    description,
    linkText,
    crmType,
    setShowLoader,
    setCurrentStep,
  } = props;

  return (
    <GenericEmptyState
      crmLogoData={crmLogoData}
      title={title}
      description={description}
    >
      <Button
        btnText={linkText}
        icon={false}
        type="button"
        className="link-btn"
        click={async () => {
          setShowLoader(true);
          Utils.mixpanelTrack(
            MX_ENRICHMENT_EVENTS.CRM_ENRICHMENT_CONNECT_CLICKED,
          );
          await crmIntegrationState.connectToCrm({
            crmType: crmType.toUpperCase(),
            successCallback: () => {
              enrichmentState.setEnrichmentStepsCompleted({ CONNECT: true });
              setCurrentStep(1);
            },
          });
          setShowLoader(false);
        }}
      />
    </GenericEmptyState>
  );
};

const GenericEmptyState = props => {
  const { crmLogoData, title, description, children } = props;

  const Icon = crmLogoData.imgComponent;
  return (
    <div className="no-connection-wrapper">
      <div className="icon-wrapper">
        <span className="icon-box">
          <AdaptIcon />
        </span>
        <SwapIcon className="swap-icon" />
        <span className="icon-box">
          {crmLogoData.isSvg ? (
            <Icon className="logo" />
          ) : (
            <img src={Icon} alt={crmLogoData.title} className="logo" />
          )}
        </span>
      </div>
      <div className="title">{title}</div>
      <div className="message">{description}</div>
      {children}
    </div>
  );
};

export default EmptyStateMessage;

export { GenericEmptyState };
